import React, { useEffect, useState } from "react";
import download from "../../assets/clarity_download-line.png";
import eye from "../../assets/eye.png";
import doc from "../../assets/lsicon_report-outline.png";
import close from "../../assets/closeIcon.png";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectButton from "../../components/SelectButton";
import { useSelector } from "react-redux";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  approveSuccess: "partner-approve-success-toast",
  approveError: "partner-approve-error-toast",
  rejectSuccess: "partner-reject-success-toast",
  rejectError: "partner-reject-error-toast",
};

function RegistrationPartnerDetails() {
  const navigate = useNavigate();
  const [investorDetails, setInvestorDetails] = useState([]);
  const location = useLocation();
  const id = location?.state?.uniqueId;
  const [approvePopupVisible, setApprovePopupVisible] = useState(false);
  const [rejectPopupVisible, setRejectPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [characterCount, setCharacterCount] = useState(0);

  const { userPermissionData } = useSelector((state) => state.userPermission);

  // Approve Handlers
  const handleApproveClick = (message) => {
    setPopupMessage(message);
    setApprovePopupVisible(true);
  };

  const closeApprovePopup = () => {
    setApprovePopupVisible(false);
    setPopupMessage("");
  };

  // Reject Handlers
  const handleRejectClick = () => {
    setRejectPopupVisible(true);
  };

  const closeRejectPopup = () => {
    setRejectPopupVisible(false);
    setReason("");
    setRemarks("");
    setCharacterCount(0);
  };

  const handleReasonChange = (value) => setReason(value);

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
    setCharacterCount(e.target.value.length);
  };

  const handleSubmit = () => {
    console.log("Reason:", reason);
    console.log("Remarks:", remarks);
    approvePartner("query");
    closeRejectPopup();
  };
  console.log(location);

  const [error, setError] = useState(null);
  const options = ["Incorrect Details", "Incorrect Demat Details"];

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/partner/${id}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      setInvestorDetails(response?.data?.data?.investorDetails);
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, []);

  const downloadRegistorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/partner/export-to-excel/${id}`;
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
        responseType: "blob",
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary link to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "investor_details.xlsx"; // Provide a default file name

      // Append the link to the document and trigger the click
      document.body.appendChild(link);
      link.click();

      // Clean up the link and blob URL
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      console.log("File downloaded successfully!");
      console.log(response, "response-download");
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  const onDownloadClick = () => {
    downloadRegistorDetails();
  };

  const approvePartner = async (updatedStatus) => {
    const endpoint = `${base_url}/${api_type}/partner/${id}/statusUpdate`;
    const payload = {
      status: updatedStatus,
      ...(updatedStatus === "query" && {
        // reason: reason, // Include only if rejected
        remarks: remarks,
      }),
    };

    try {
      const response = await axios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      if (!toast.isActive(toastIds.approveSuccess)) {
        toast.success(
          response?.data?.message || "Status updated successfully!",
          {
            toastId: toastIds.approveSuccess,
            onClose: () => navigate("/registration/wealth-partner"),
            autoClose: 3000,
          }
        );
      }
    } catch (err) {
      if (!toast.isActive(toastIds.approveError)) {
        toast.error(
          err?.response?.data?.message ||
            "Failed to update investor status. Please try again.",
          {
            onClose: () => navigate("/registration/wealth-partner"),
            toastId: toastIds.approveError,
            autoClose: 3000,
          }
        );
      }
      console.error("Failed to update status:", err);
      setError(err.message);
    }
  };
  const handleApproveSubmit = () => {
    approvePartner("approve");
    closeApprovePopup();
  };

  const rejectPartner = async (updatedStatus) => {
    const endpoint = `${base_url}/${api_type}/partner/${id}/statusUpdate`;
    const payload = {
      status: "rejected",
      // ...(updatedStatus === "rejected" && {
      //   reason: reason, // Include only if rejected
      //   remarks: remarks,
      // }),
    };

    try {
      const response = await axios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      if (!toast.isActive(toastIds.rejectSuccess)) {
        toast.success(
          response?.data?.message || "Status updated successfully!",
          {
            toastId: toastIds.rejectSuccess,
            onClose: () => navigate("/registration/wealth-partner"),
            autoClose: 3000,
          }
        );
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        "Failed to update Partner status. Please try again.";
      if (!toast.isActive(toastIds.rejectError)) {
        toast.error(errorMessage, {
          onClose: () => navigate("/registration/wealth-partner"),
          toastId: toastIds.rejectError,
          autoClose: 3000,
        });
      }
      console.error("Failed:", err?.response);
      setError(err.message);
    }
  };
  const handleReject = () => {
    rejectPartner();
    closeRejectPopup();
  };

  const handleOpenImage = (url) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      toast.error("No document found");
    }
  };

  const formatISOToDate = (isoDate) => {
    if (!isoDate) return ""; // Handle empty case
    return new Date(isoDate).toISOString().split("T")[0]; // Extract yyyy-mm-dd
  };
  console.log("details", investorDetails);
  return (
    <div className=" mt-20  rounded-[20px] bg-white ml-4">
      <div className="border-2 rounded-[20px]">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">
            Personal Details
          </h1>
          {userPermissionData?.registration?.download && (
            <div
              onClick={onDownloadClick}
              class="flex items-center bg-[#035C98] px-4 rounded-[8px]"
            >
              <button class="btn   text-white font-bold  ">Download</button>
              <img src={download} alt="download" />
            </div>
          )}
        </div>
        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">IR No.</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.irNo || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.name || "xxxx"}
            </p>
          </div>
          {/* <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Mother Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.motherName || "xxxx"}
            </p>
          </div> */}
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Father Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.address?.split(":")[1]?.split(",")[0]?.trim() ||
                "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Gender </label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.gender || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Date of Birth {`(YYYY-MM-DD)`}</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {formatISOToDate(investorDetails?.dob) || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Phone No.</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.mobileNumber || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Email Id</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.email || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">PAN</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.panCardNumber || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Aadhar Number</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.aadharCardNumber || "xxxx"}
            </p>
          </div>
          {/* <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Address</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.address || "xxxx"}
            </p>
          </div> */}
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Address</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 text-wrap break-words">
              {investorDetails?.address || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Pin Code</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.zipcode || "xxxx"}
            </p>
          </div>
        </div>
      </div>
      <div className="border-2 rounded-[20px] mt-5">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">Bank Details</h1>
        </div>
        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Account Holder Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.accountName || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Account Number</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.accountNumber || "xxxx"}
            </p>
          </div>
          {/* <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Bank Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.ifscCode || "xxxx"}
            </p>
          </div> */}
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">IFSC Code</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.ifscCode || "xxxx"}
            </p>
          </div>
          {/* <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Branch</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.ifscCode || "xxxx"}
            </p>
          </div> */}
        </div>
      </div>
      <div className="border-2 rounded-[20px] mt-5">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">
            Uploaded Document
          </h1>
        </div>
        <div className="w-full flex flex-wrap gap-x-5 mt-2 py-2">
          <div className="px-4 py-2 md:w-[20%]">
            {/* <label className=" py-2">Aadhar Card</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between ">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                <p>{"Aadhar Card"}</p>
              </div>
              <img
                src={eye}
                alt="eye"
                onClick={() => handleOpenImage(investorDetails?.aadharCardDoc)}
                className="cursor-pointer"
              />
            </div>
          </div>
          <div className="px-4 py-2 md:w-[20%]">
            {/* <label className=" py-2">Pan Card</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between ">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                <p>{"Pan Card"} </p>
              </div>
              <img
                src={eye}
                alt="eye"
                onClick={() => handleOpenImage(investorDetails?.panCardDoc)}
                className="cursor-pointer"
              />
            </div>
          </div>

          <div className="px-4 py-2 md:w-[20%]">
            {/* <label className=" py-2">Bank Cheque</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between ">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                <p>{"Bank Cheque"} </p>
              </div>
              <img
                src={eye}
                alt="eye"
                onClick={() => handleOpenImage(investorDetails?.chequeDoc)}
                className="cursor-pointer"
              />
            </div>
          </div>
          <div className="px-4 py-2 md:w-[20%]">
            {/* <label className=" py-2">Bank Cheque</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between ">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                <p>{"Signature"} </p>
              </div>
              <img
                src={eye}
                alt="eye"
                onClick={() => handleOpenImage(investorDetails?.signature)}
                className="cursor-pointer"
              />
            </div>
          </div>
          <div className="px-4 py-2 md:w-[35%]">
            {/* <label className=" py-2">Wealth Partner Agreement Form</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between ">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                <p>{"Wealth Partner Agreement Form"} </p>
              </div>
              <img
                src={eye}
                alt="eye"
                onClick={() =>
                  handleOpenImage(investorDetails?.accountOpeningForm)
                }
                className="cursor-pointer"
              />
            </div>
          </div>
          <div className="px-4 py-2 md:w-[25%]">
            {/* <label className=" py-2">Wealth Partner Agreement Form</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between ">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                <p>{"NISM Certificate"} </p>
              </div>
              <img
                src={eye}
                alt="eye"
                onClick={() =>
                  handleOpenImage(investorDetails?.nismCertificate)
                }
                className="cursor-pointer"
              />
            </div>
          </div>
          <div className="px-4 py-2 md:w-[20%]">
            {/* <label className=" py-2">Wealth Partner Agreement Form</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between ">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                <p>{"Selfie"} </p>
              </div>
              <img
                src={eye}
                alt="eye"
                onClick={() => handleOpenImage(investorDetails?.selfie)}
                className="cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center pt-10 pb-10">
        <div
          onClick={() => navigate("/registration/wealth-partner")}
          className="w-[150px] rounded-[8px] border-2 py-2 px-6 flex justify-center cursor-pointer"
        >
          Back
        </div>
        {investorDetails?.kycStatus !== "approve" && (
          <div className="flex">
            {investorDetails?.kycStatus !== "pending" && (
              <>
                {userPermissionData?.registration?.approval && (
                  <div
                    onClick={handleRejectClick}
                    className="mr-4 min-w-[150px] cursor-pointer text-[#035C98] rounded-[8px] border-2 py-2 px-6 flex justify-center"
                  >
                    Reject / Submit Query
                  </div>
                )}
              </>
            )}
            {userPermissionData?.registration?.approval && (
              <div
                onClick={() =>
                  handleApproveClick("Are you sure you want to approve?")
                }
                className="min-w-[150px] cursor-pointer bg-[#035C98] text-white rounded-[8px] border-2 py-2 px-6 flex justify-center"
              >
                Approve
              </div>
            )}
          </div>
        )}

        {approvePopupVisible && (
          <div className=" fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-[400px] text-center">
              <div className="flex justify-between">
                <p className="mb-4 font-bold">{popupMessage}</p>
                <img
                  src={close}
                  alt="close"
                  className="w-4 h-4"
                  onClick={closeApprovePopup}
                />
              </div>
              <div className="flex justify-end gap-x-2">
                <button
                  className=" text-[#313131] rounded-md py-2 px-4 border-2"
                  onClick={closeApprovePopup}
                >
                  Cancel
                </button>
                <button
                  className="bg-[#429A3A] text-white rounded-md py-2 px-4"
                  onClick={() => {
                    console.log("Action confirmed");
                    handleApproveSubmit();
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {rejectPopupVisible && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-[400px] relative">
              {/* Close Button */}

              {/* Title */}
              <div className="flex justify-between items-center">
                <h2 className="text-lg font-bold mb-4">
                  Are you sure, you want to return to wealth partner?
                </h2>
                <img
                  src={close}
                  alt="close"
                  className="w-4 h-4"
                  onClick={closeRejectPopup}
                />
              </div>

              {/* Form */}
              {/* <div className="mb-4">
              <label className="block font-medium mb-2">Select Reason</label>
              <SelectButton
                options={options}
                selectedValue={reason}
                onSelect={handleReasonChange}
              />
            </div> */}

              <div className="mb-4">
                <label className="block font-medium mb-2">
                  Remarks (If any)
                </label>
                <textarea
                  value={remarks}
                  onChange={handleRemarksChange}
                  maxLength={500}
                  placeholder="Remark"
                  className="w-full border rounded-md px-3 py-2 h-20"
                />
                <div className="text-right text-sm text-gray-500">
                  {characterCount}/500
                </div>
              </div>

              {/* Buttons */}
              {/* <div className="flex justify-end space-x-2">
              <button
                className="border border-gray-300 text-gray-600 px-4 py-2 rounded-md hover:bg-gray-100"
                onClick={closeRejectPopup}
              >
                Cancel
              </button>
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                onClick={handleSubmit}
              >
                Return
              </button>
            </div> */}

              <div className="flex justify-between space-x-2">
                <div>
                  <button
                    className="border bg-red-500 border-gray-300 text-white px-4 py-2 rounded-md hover:bg-gray-100"
                    onClick={handleReject}
                  >
                    Reject
                  </button>
                </div>
                <div className="space-x-2">
                  <button
                    className="border border-gray-300 text-gray-600 px-4 py-2 rounded-md hover:bg-gray-100"
                    onClick={closeRejectPopup}
                  >
                    Cancel
                  </button>
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                    onClick={handleSubmit}
                  >
                    Query
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RegistrationPartnerDetails;
